const rankingItems = [
  { rank: 1, title: '速度与激情12', type: '动作片', hot: '🔥 9.8', change: '↑' },
  { rank: 2, title: '庆余年 第三季', type: '国产剧', hot: '🔥 9.7', change: '↑' },
  { rank: 3, title: '三体：黑暗森林', type: '科幻剧', hot: '🔥 9.6', change: 'NEW' },
  { rank: 4, title: '雾山五行 第二季', type: '动画', hot: '🔥 9.5', change: '↑' },
  { rank: 5, title: '向往的生活 第八季', type: '综艺', hot: '🔥 9.3', change: '↓' },
  { rank: 6, title: '流浪地球3', type: '科幻片', hot: '🔥 9.2', change: '↓' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-3 whitespace-nowrap">
            热播排行
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            大家都在看 · 实时热度榜
          </h2>
        </div>
        <div className="bg-background-50 rounded-xl overflow-hidden">
          <div className="hidden md:grid grid-cols-12 gap-4 px-6 py-3 border-b border-background-200/70 text-xs font-medium text-foreground-400">
            <span className="col-span-1">排名</span>
            <span className="col-span-5">影片名称</span>
            <span className="col-span-2">类型</span>
            <span className="col-span-2">热度</span>
            <span className="col-span-2">趋势</span>
          </div>
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className="grid grid-cols-1 md:grid-cols-12 gap-2 md:gap-4 px-6 py-4 border-b border-background-200/50 last:border-b-0 hover:bg-background-100 transition-colors cursor-pointer items-center"
            >
              <div className="md:col-span-1 flex items-center gap-3">
                <span
                  className={`flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-lg text-xs font-bold ${
                    item.rank <= 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-200 text-foreground-500'
                  }`}
                >
                  {item.rank}
                </span>
                <span className="md:hidden font-semibold text-foreground-900 text-sm">
                  {item.title}
                </span>
              </div>
              <span className="hidden md:block md:col-span-5 font-semibold text-foreground-900 text-sm">
                {item.title}
              </span>
              <span className="hidden md:block md:col-span-2">
                <span className="inline-block px-2.5 py-0.5 rounded-full text-[10px] font-medium bg-secondary-100 text-secondary-700 whitespace-nowrap">
                  {item.type}
                </span>
              </span>
              <span className="hidden md:block md:col-span-2 text-sm font-semibold text-accent-600">
                {item.hot}
              </span>
              <span className="hidden md:block md:col-span-2">
                <span
                  className={`inline-block px-2 py-0.5 rounded text-xs font-bold ${
                    item.change === '↑'
                      ? 'text-green-600'
                      : item.change === 'NEW'
                        ? 'text-accent-600'
                        : 'text-foreground-400'
                  }`}
                >
                  {item.change}
                </span>
              </span>
              <div className="md:hidden flex items-center gap-2 text-xs text-foreground-500 pl-10">
                <span className="inline-block px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                  {item.type}
                </span>
                <span className="font-semibold text-accent-600">{item.hot}</span>
                <span
                  className={`font-bold ${
                    item.change === '↑'
                      ? 'text-green-600'
                      : item.change === 'NEW'
                        ? 'text-accent-600'
                        : 'text-foreground-400'
                  }`}
                >
                  {item.change}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}